// Lightweight HTML → Markdown converter for the WYSIWYG composer.
// Operates on the innerHTML of a contenteditable div at send time.
// Only handles the subset of HTML that execCommand / the toolbar produce.

const _escape = (t) => t.replace(/([*_~`\[\]])/g, '\\$1')

const _walk = (node) => {
  if (node.nodeType === 3) return node.textContent
  if (node.nodeType !== 1) return ''

  const tag = node.tagName.toLowerCase()
  const children = [...node.childNodes].map(_walk).join('')

  switch (tag) {
    case 'b': case 'strong': return `**${children}**`
    case 'i': case 'em': return `*${children}*`
    case 's': case 'del': case 'strike': return `~~${children}~~`
    case 'u': return children // markdown has no underline, keep plain
    case 'code': return `\`${children}\``
    case 'pre': return `\n\`\`\`\n${node.textContent}\n\`\`\`\n`
    case 'a': {
      const href = node.getAttribute('href') || ''
      return href ? `[${children}](${href})` : children
    }
    case 'br': return '\n'
    case 'div': case 'p': return children ? `\n${children}\n` : '\n'
    case 'blockquote': return children.split('\n').map(l => l ? `> ${l}` : '').join('\n')
    case 'h1': return `\n# ${children}\n`
    case 'h2': return `\n## ${children}\n`
    case 'h3': return `\n### ${children}\n`
    case 'h4': return `\n#### ${children}\n`
    case 'h5': return `\n##### ${children}\n`
    case 'h6': return `\n###### ${children}\n`
    case 'ul': return '\n' + [...node.children].map(li => `- ${_walk(li).trim()}`).join('\n') + '\n'
    case 'ol': return '\n' + [...node.children].map((li, i) => `${i + 1}. ${_walk(li).trim()}`).join('\n') + '\n'
    case 'li': return children
    case 'hr': return '\n---\n'
    case 'img': {
      const src = node.getAttribute('src') || ''
      const alt = node.getAttribute('alt') || ''
      return `![${alt}](${src})`
    }
    default: return children
  }
}

// Convert a contenteditable div's innerHTML to clean markdown.
// Collapses redundant blank lines and trims.
export const htmlToMarkdown = (html) => {
  if (!html || !html.trim()) return ''
  const div = document.createElement('div')
  div.innerHTML = html
  const md = _walk(div)
  // Collapse excessive blank lines, strip non-breaking spaces, then trim.
  return md.replace(/\u00A0/g, ' ').replace(/\n{3,}/g, '\n\n').trim()
}

// Convert plain text with line breaks to basic HTML for initial
// contenteditable population.
export const textToHtml = (text) => {
  if (!text) return ''
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\n/g, '<br>')
}
